export const jobLoadsKeys = {
    all: ['job-loads'] as const,
    forJob: (jobId: string) => [...jobLoadsKeys.all, jobId] as const,
}
